(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion-content"] && !Shopify.designMode) return;
  try {
    const initAccordionViewMore = () => {
    document.querySelectorAll('[data-accordion-item][data-display-mode="view_more"]').forEach((item) => {
      if (item.dataset.viewMoreInitialized === 'true') return;

      item.dataset.viewMoreInitialized = 'true';

      const content = item.querySelector('[data-accordion-view-more-content]');
      const button = item.querySelector('[data-accordion-view-more-toggle]');

      if (!content || !button) return;

      const maxHeight = () => {
        const rawValue = getComputedStyle(content).getPropertyValue('--accordion-content-max-height').trim();
        const parsed = Number.parseFloat(rawValue);
        return Number.isFinite(parsed) ? parsed : 224;
      };

      const updateButton = () => {
        const expanded = item.classList.contains('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
      };

      const refresh = () => {
        const shouldShow = content.scrollHeight > maxHeight() + 4;

        button.hidden = !shouldShow;

        if (!shouldShow) {
          item.classList.add('is-expanded');
        }

        updateButton();
      };

      button.addEventListener('click', () => {
        item.classList.toggle('is-expanded');
        updateButton();
      });

      refresh();

      window.addEventListener('resize', refresh, { passive: true });
    });
  };

  const initAccordionCollapseScroll = () => {
    document.querySelectorAll('[data-accordion-item][data-display-mode="collapse"]').forEach((item) => {
      if (item.dataset.collapseScrollInitialized === 'true') return;

      item.dataset.collapseScrollInitialized = 'true';

      item.addEventListener('toggle', () => {
        if (!item.open) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = prefersReducedMotion ? 'auto' : 'smooth';

        window.requestAnimationFrame(() => {
          item.scrollIntoView({
            behavior,
            block: 'start',
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionViewMore, { once: true });
    document.addEventListener('DOMContentLoaded', initAccordionCollapseScroll, { once: true });
  } else {
    initAccordionViewMore();
    initAccordionCollapseScroll();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    const initAccordionGroups = () => {
    document.querySelectorAll('[data-accordion][data-single-open="true"]').forEach((accordion) => {
      if (accordion.dataset.initialized === 'true') return;

      accordion.dataset.initialized = 'true';

      accordion.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;

          accordion.querySelectorAll('details').forEach((sibling) => {
            if (sibling !== details) {
              sibling.open = false;
            }
          });
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionGroups, { once: true });
  } else {
    initAccordionGroups();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["free-gift"] && !Shopify.designMode) return;
  try {
    async function runFreeGift() {
		let freeGiftConfig = false;

		// document.addEventListener("cart:refresh", (e) => {
		// 	console.log("cart:refresh", e);
		// });

		// document.addEventListener("theme:loading:start", (e) => {
		// 	console.log("theme:loading:start", e);
		// });

		document.addEventListener("product:added", (e) => {
			// console.log("product:added", e);

			if (e.detail?.target == "productPageAddToCart" && e.detail?.variant) {
				const variantId = parseInt(e.detail?.variant);
				// console.log("run getFreeGiftConfig");
				freeGiftConfig = getFreeGiftConfig(variantId);
			} else {
				// console.log("not run getFreeGiftConfig");
				return;
			}
		});

		document.addEventListener("theme:loading:end", (e) => {
			// console.log("theme:loading:end", e);
			// console.log(freeGiftConfig);

			if (e.detail?.target == "_onCartRefreshCart" && freeGiftConfig) {
				// console.log("run updateFreeGift: _onCartRefreshCart", freeGiftConfig);
				updateFreeGift(freeGiftConfig);
				freeGiftConfig = false;
			} else if (e.detail?.target == "_updateQuantityCart") {
				const variantId = parseInt(e.detail?.variantId);
				freeGiftConfig = getFreeGiftConfig(variantId);

				// console.log("run updateFreeGift: _updateQuantityCart", freeGiftConfig);
				updateFreeGift(freeGiftConfig);
				freeGiftConfig = false;
			} else {
				return;
				// console.log("not run updateFreeGift");
			}
		});
	}

	runFreeGift();

	function getFreeGiftConfig(id) {
		const isValid = Number.isInteger(id);

		if (!isValid) return;

		return window.freeGiftConfigs.find(
			config => parseInt(config.upsellId) == id
		);
	}

	async function updateFreeGift(config) {
		if (!config?.enabled) return;

		const cart = await fetch(
			window.Shopify.routes.root + 'cart.js'
		).then(response => response.json());

		const qualifyingItem = cart.items.find(item => {
			return item.variant_id === config?.upsellId;
		});

		const alreadyHasGift = cart.items.find(item => {
			return Number(item.properties._free_gift_source) === Number(config?.upsellId);
		}) || false;

		// console.log('cart', cart, 'qualifyingItem', qualifyingItem, 'alreadyHasGift', alreadyHasGift);

		if (!qualifyingItem || qualifyingItem.quantity < config?.minimumQuantity) {
			if (alreadyHasGift) {
				await removeFreeGift(alreadyHasGift.key);
			}

			return;
		}

		if (!alreadyHasGift) {
			await addFreeGift(Number(config.giftVariantId), qualifyingItem);
		}
	}

	/**
	* Add FREE GIFT
	*/
	async function addFreeGift(giftVariantId, qualifyingItem) {
		const response = await fetch(
			window.Shopify.routes.root + 'cart/add.js',
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					items: [
						{
							id: giftVariantId,
							quantity: 1,
							properties: {
								"_free_gift": "true",
								"_free_gift_source": `${qualifyingItem.id}`,
								"_free_gift_source_variant_id": `gid://shopify/ProductVariant/${qualifyingItem.id}`,
								"_free_gift_source_title": `free gift Product ${qualifyingItem.title}`
							}
						}
					]
				})
			}
		);

		if (!response.ok) {
			throw new Error('Failed to add free gift');
		}

		// console.log('free gift added');

		document.documentElement.dispatchEvent(new CustomEvent('product:added', {
			bubbles: true,
			detail: {
				quantity: 1
			}
		}));

		return response.json();
	}

	/**
	* Remove FREE GIFT
	*/
	async function removeFreeGift(lineKey) {
		const response = await fetch(
			window.Shopify.routes.root + 'cart/change.js',
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					id: lineKey,
					quantity: 0
				})
			}
		);

		if (!response.ok) {
			throw new Error('Failed to remove free gift');
		}

		// console.log('free gift removed');

		document.documentElement.dispatchEvent(new CustomEvent('product:added', {
			bubbles: true,
			detail: {
				quantity: 1
			}
		}));

		return response.json();
	}
  } catch(e) { console.error(e); }
})();

})();
